import { render, staticRenderFns } from "./PrkMainSyllabusHeader.vue?vue&type=template&id=594ab127&scoped=true&"
import script from "./PrkMainSyllabusHeader.vue?vue&type=script&lang=js&"
export * from "./PrkMainSyllabusHeader.vue?vue&type=script&lang=js&"
import style0 from "./PrkMainSyllabusHeader.vue?vue&type=style&index=0&id=594ab127&scoped=true&lang=scss&"
import style1 from "./PrkMainSyllabusHeader.vue?vue&type=style&index=1&id=594ab127&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594ab127",
  null
  
)

export default component.exports